import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import API from "../../api/axiosConfig";
import { toast } from "react-toastify";
import { X } from "lucide-react";

export default function SeccionModal({ seccion, onClose, onSaved }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const [name, setName] = useState(seccion?.name || "");
  const isEdit = Boolean(seccion);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.warn("El nombre es obligatorio");
      return;
    }
    try {
      if (isEdit) {
        await API.put(`/secciones/${seccion.id ?? seccion._id}`, { name });
      } else {
        const companyId = user?.company?.id ?? user?.company?._id ?? user?.companyId;
        await API.post("/secciones", { name, companyId });
      }
      toast.success(isEdit ? "Sección actualizada" : "Sección creada");
      onSaved();
      onClose();
    } catch (err) {
      toast.error("Error guardando la sección");
    }
  };

  return (
    <AnimatePresence>
      <motion.div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        <motion.div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-lg relative max-h-[90vh] overflow-y-auto"
          initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.9, opacity: 0 }}>
          <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600">
            <X size={20} />
          </button>
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            {isEdit ? "Editar sección" : "Nueva sección"}
          </h3>
          <form onSubmit={handleSubmit} className="grid gap-4">
            <input placeholder="Nombre de la sección"
              className="border border-gray-300 rounded-lg p-3"
              value={name}
              onChange={(e) => setName(e.target.value)} />
            <button className="bg-supernova-500 hover:bg-supernova-600 text-white py-2 rounded-lg">
              {isEdit ? "Guardar cambios" : "Crear sección"}
            </button>
          </form>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}